export default __webpack_public_path__ + "static/media/chevron-right.75b05190.svg";